import { render, staticRenderFns } from "./EventViewRegistrationList.vue?vue&type=template&id=1fa48f8a&"
import script from "./EventViewRegistrationList.vue?vue&type=script&lang=js&"
export * from "./EventViewRegistrationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports